<script>
import courses from '@/global/js/courses'
import states from '@/global/js/states'
import ethnicities from '@/global/js/ethnicities'
import genders from '@/global/js/genders'
import countries from '@/global/js/countries'
import nonTaxableIncomes from '@/global/js/nonTaxableIncomes'
import educationLevels from '@/global/js/educationLevels'
import employmentStatus from '@/global/js/employmentStatus'
import ProInput from '$common/ProInput'
import ProSelect from '$common/ProSelect'
import DiscountCode from '$common/DiscountCode'
import AddGiftCard from '$common/AddGiftCard'
export default {
  name: 'GuardianSignUp',
  components: {
    'pro-input': ProInput,
    'pro-select': ProSelect,
    'discount-code': DiscountCode,
    'add-gift-card': AddGiftCard,
  },
  watch: {
    selfEnrolling () {
      if (this.selfEnrolling) {
        this.form.student.name = this.user.name
      } else {
        this.form.student.name = ''
      }
    },
  },
  data () {
    return {
      student: {},
      allStudents: {},
      applications: [],
      courses,
      classes: {},
      selfEnrolling: false,
      
      ethnicities,
      genders,
      states,
      countries,
      nonTaxableIncomes,
      educationLevels,
      employmentStatus,

      appliedDiscountCode: null,
      appliedGiftCard: null,
      selectedClasses: [],
      applyingForScholarship: false,
      card: null,
      stripe: null,
      cardReady: false,
      isLoading: false,
      form: {
        student: {
          name: '',
          birthday: '',
          ethnicity: null,
          gender: null,
          gender_self_description: '',
          outside_of_us: false,
          city: '',
          state: '',
          country: '',
          previous_coding_experience: '',
          want_to_learn_next: '',
        },
        scholarship: {
          can_pay: '',
          annual_income: '',
          zip_code: '',
          adult_count: '',
          child_count: '',
          non_taxable_incomes: [],
        },
        adultStudent: {
          military_or_vet: false,
          employment_status: null,
          education_level: null,
          coding_barriers: '',
          message: ''
        }
      },
      formOptions: {
        student: {
          name: {
            title: 'First and Last Name',
            errorIf: (val) => val ? '' : 'Enter name',
          },
          birthday: {
            errorIf: val => val ? '' : 'Enter birthday',
          },
          ethnicity: {
            errorIf: val => val ? '' : 'Enter ethnicity',
          },
          gender: {
            errorIf: val => val ? '' : 'Enter gender', 
          },
          gender_self_description: {
            errorIf: (val) => (this.form.student.gender === 'Prefer to self-describe') && !val ? 'Input self-described gender' : '',
          },
          outside_of_us: {
            errorIf: val => '',
          },
          city: {
            errorIf: val => val ? '' : 'Enter city',
          },
          state: {
            errorIf: (val) => !this.form.student.outside_of_us && !val ? 'Enter state' : '',
          },
          country: {
            errorIf: (val) => this.form.student.outside_of_us && !val ? 'Enter country' : '',
          },
          previous_coding_experience: {
            errorIf: val => '',
            title: 'Previous coding experience (ex. HTML, CSS, and a little bit of Python)',
          },
          want_to_learn_next: {
            errorIf: val => '',
            title: 'What you want to learn next (ex. I’m programming a project in Python for school and need help)',
          },
        },
        scholarship: {
          can_pay: {
            title: 'How much of the total course cost can you afford to pay?',
            errorIf: val => val != undefined ? (Number(val) >= 0) ? '' : 'Amount must be greater than or equal to $0' : 'Enter the amount you can pay monthly',
            type: 'number',
          },
          annual_income: {
            title: 'What is your annual income?',
            errorIf: val => val != undefined ? (Number(val) >= 0) ? '' : 'Amount must be greater than or equal to $0' : 'Enter your annual income',
            type: 'number',
          },
          zip_code: {
            title: 'What is your zip code?',
            errorIf: val => this.$regex.is(val).a('zip') ? '' : 'Enter your zip code',
            type: 'number',
          },
          adult_count: {
            title: 'How many adults live in your home?',
            errorIf: val => val || (val === 0) ? '' : 'Enter number of adults in your home',
            type: 'number',
          },
          child_count: {
            title: 'How many children live in your home?',
            errorIf: val => val || (val === 0) ? '' : 'Enter number of children in your home',
            type: 'number',
          },
          non_taxable_incomes: {
            errorIf: val => val.length ? '' : 'Select a response for non-taxable income',
          },
        },
        adultStudent: {
          military_or_vet: {
            title: 'I am currently active military or a U.S. veteran.',
            errorIf: val => '',
            type: 'checkbox',
          },
          employment_status: {
            title: 'Current Employment Status',
            errorIf: val => val ? '' : 'Choose an employment status.',
          },
          education_level: {
            title: 'What is your highest level of education?',
            errorIf: val => val ? '' : 'Choose your education level.',
          },
          coding_barriers: {
            title: 'What barriers have you experienced to learning how to code, if any?',
            errorIf: val => '',
          },
          message: {
            title: 'Is there anything else that you want our team to know?',
            errorIf: val => '',
          },
        },
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    studentId () {
      return this.$route.params.studentId
    },
    newStudent () {
      return this.$route.params.newStudent && !this.studentId
    },
    isAdultStudent () {
      return this.$route.params.isAdultStudent
    },
    totalClasses () {
      return this.selectedClasses.length
    },
    costPerClass () {
      return this.isAdultStudent ? 200 : 150
    },
    totalCost () {
      return this.totalClasses * this.costPerClass - this.totalGiftCardAmount - this.totalDiscountCodeAmount
    },
    totalDiscountCodeAmount () {
      return (this.totalClasses - this.giftCardVouchersApplied) * (this.appliedDiscountCode ? this.appliedDiscountCode.amount : 0)
    },
    giftCardVouchersApplied () {
      if (!this.appliedGiftCard)
        return 0
      else
        return this.totalClasses <= this.appliedGiftCard.vouchers_available ?
          this.totalClasses : this.appliedGiftCard.vouchers_available
    },
    totalGiftCardAmount () {
      return this.giftCardVouchersApplied * this.costPerClass
    },
    studentRef () {
      return this.newStudent ? this.form.student : this.student
    },
    hasPendingScholarship () {
      return (['PENDING', 'PENDING_NOT_PAID', 'SCHOLARSHIP_REBUTTED'].includes(this.user.application_status))
    },
    newScholarshipTotal () {
      if(this.applications.length)
      return Number(this.applications[0].can_pay) + Number(this.form.scholarship.can_pay)
      else return 0
    },
    enrollmentTitle () {
      let pronoun = 'Adult Learner'
      if (!this.isAdultStudent) pronoun = 'Student'
      else if (this.selfEnrolling) pronoun = 'Your'
      return `Enter ${pronoun} Information`
    },
  },
  methods: {
    getAge (birthday) {
      //this is a copy paste of the prototype function $getAge
      //for some reason mobile devices weren't calling it, so it's reproduced here
      birthday = new Date(`${birthday}`)
      const today = new Date()
      const diff = today - birthday
      const yearsOld = diff / 1000 / 3600 / 24 / 365.2422 //converts ms to years
      return Math.floor(yearsOld)
    },
    getCoursesForStudent () {
      if (!this.isAdultStudent) {

        // if student doesn't have a birthday on record, show all classes
        if (!this.studentRef.birthday) 
          return Object.values(this.courses)
            .filter(aClass => aClass.courseType == 'youth')

        const studentAge = this.getAge(this.studentRef.birthday)
        return Object.values(this.courses)
          .filter(course => {
            //allow a 1 year grace period for min age
            return (course.minAge <= studentAge + 1) && (course.maxAge >= studentAge)
          })
      } else {
        // console.log('getting adult courses')
        return Object.values(this.courses)
          .filter(course => {
            return course.courseType == 'adult'
          })
      }
    },
    isClassFull (classId) {
      const capacity = courses[this.classes[classId].course_id].capacity
      const currentlyEnrolled = this.allStudents.filter(student => {
        const classes = student.classes
        if (!classes) return false
        return classes.includes(classId)
      }).length
      return currentlyEnrolled >= capacity
    },
    getClassClasses (classId) {
      if (!this.allStudents.length) return ''
      const classes = []
      if (this.selectedClasses.includes(classId)) classes.push('chosen')
      if (this.isClassFull(classId)) classes.push('full')
      if (!this.newStudent && this.student.classes && this.student.classes.includes(classId)) classes.push('enrolled')
      return classes.join(' ')
    },
    async retrieveStudents() {
      try {
        this.allStudents = (await this.$firestore.collection('users')
          .where('user_type', 'array-contains-any', ['ONLINE_STUDENT','ADULT_STUDENT'])
          .get()).docs.map(doc => doc.data())
      } catch (err) {
        console.error('Could not get students: ', err)
      }
    },
    async retrieveScholarships() {
      try {
        this.applications = (await this.$firestore.collection('scholarship_applications')
          .where('guardian_id', '==', this.user.id)
          .get()).docs.map(doc => doc.data())
      } catch (e) {
        console.log('No applications to retrieve.')
      }

      if (!this.applications.length) return

      // filter out application types that don't match current sign up
      // ^ currently not doing this as users can only have one pending scholarship at a time
      // sort so newest are at the beginning of the array
      this.applications
        // .filter((app) => app.type == this.isAdultStudent ? 'adult' : 'youth')
        .sort((a, b) => (a.created > b.created) ? -1 : 1)
      // populate form.scholarship with most recent info
      Object.keys(this.form.scholarship).forEach((key) => {
        if (key !== 'can_pay') this.form.scholarship[key] = this.applications[0][key]
      })
    },
    onClassClick (aClass) {
      if (this.isClassFull(aClass) || (!this.newStudent && this.student.classes.includes(aClass))) return
      const classIndex = this.selectedClasses.findIndex(chosen => chosen === aClass)
      if (classIndex >= 0) this.selectedClasses.splice(classIndex,1)
      else this.selectedClasses.push(aClass)
    },
    getErrors () {
      return new Promise(async (resolve, reject) => {
        const checkErrorIfs = (type) => Object.keys(this.form[type])
          .map(key => this.formOptions[type][key].errorIf(this.form[type][key]))
          .filter(Boolean)

        const scholarshipErrors = this.applyingForScholarship ? checkErrorIfs('scholarship') : []
        const studentErrors = this.newStudent ? checkErrorIfs('student') : []
        const adultStudentErrors = this.newStudent && this.isAdultStudent ? checkErrorIfs('adultStudent') : []
        resolve([
          ...scholarshipErrors,
          ...studentErrors,
          ...adultStudentErrors,
        ])
      })
    },
    async onSubmit () {
      if (this.totalClasses < 1) return this.$toast({copy: 'Select at least 1 class', class: 'alert'})
      // validate data
      const formErrors = await this.getErrors()
      if (formErrors.length) return formErrors.forEach(err => this.$toast({copy: err, class: 'alert'}))

      let card
      if (!this.applyingForScholarship && this.totalCost > 0) {
        if (!this.cardReady) return this.$toast({copy: 'Complete card input', class: 'alert'})
        // validate card
        try {
          card = (await this.stripe.createToken(this.card)).token
        } catch (e) {
          this.$toast({
            copy: 'Problem with card',
            class: 'alert',
          })
          this.isLoading = false
          return console.log(e)
        }
      }

      // all data validated
      this.isLoading = true

      try {
        await this.$HTTP({
          method: 'post',
          uri: `users/${this.user.id}/enroll-student`,
          body: {
            isAdultStudent: this.isAdultStudent,
            student: this.studentRef,
            newStudent: this.newStudent,
            guardian: this.user,
            extraAdultInfo: this.form.adultStudent,
            newSelfEnroll: this.selfEnrolling,
            classes: this.selectedClasses,
            amount: this.totalCost < 0 ? 0 : this.totalCost,
            scholarship: this.form.scholarship,
            applyingForScholarship: this.applyingForScholarship,
            pendingScholarship: this.hasPendingScholarship ? this.applications[0] : null,
            card,
            giftCard: this.appliedGiftCard ? {
              vouchers_being_used: this.giftCardVouchersApplied,
              ...this.appliedGiftCard,
            } : null,
            discountCode: this.appliedDiscountCode,
            origin: location.origin,
          }
        })
      } catch (e) {
        console.error(e)
        this.$toast({
          copy: e.body.message,
          class: 'alert'
        })
        this.isLoading = false
        return
      }

      this.$toast({copy: 'Success!'})
      const user = (await this.$firestore.doc(`users/${this.user.id}`).get()).data()
      this.$store.commit('update', {user})
      this.$router.push({name: 'GuardianDashboard'})

    },
    setUpStripeElement () {
      if (this.stripe) return //don't need to set it up more than once
      // eslint-disable-next-line
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_KEY)
      const elements = this.stripe.elements()

      this.card = elements.create('card')

      this.card.on('change', (event) => {
        this.cardReady = event.complete
      })

      this.card.mount('#card-element')
    },
    createOptions (list) {
      return list.map(str => ({value: str, name: str}))
    },
    getBirthdayInputOptions () {
      return {
        title: 'Participant\'s birthday',
        type: 'date',
        errorIf: val => val ? '' : 'Enter birthday',
      }
    },
    isClosed (classId, classObj) {
      let today = new Date()
      let matches = /\d{4}/.exec(classId) // legacy classes have ids containing their year
      let year = ''
      if (matches == null){
        // console.log(`${classId} is a firestore class`)
        year = today.getFullYear()
      } else year = matches[0]  // else set it to the first (should be only) match
      let firstDay = classObj.details.split(',')[0]
      let month = firstDay.split('/')[0]
      let day = firstDay.split('/')[1]

      // add leading zeros as necessary
      if (month.length == 1) month = '0' + month
      if (day.length == 1) day = '0' + day
      
      let dateString = `${year}-${month}-${day}T18:00:00Z` // 1 PM EST
      let deadline = new Date(dateString)
      return today >= deadline
    }, 
    hasOpenClasses (courseId) {
      let hasOpenClasses = false
      Object.keys(this.classes).forEach(classId => {
        if (this.classes[classId].course_id === courseId && !this.isClosed(classId, this.classes[classId]) && !this.classes[classId].done)
          hasOpenClasses = true
      })
      return hasOpenClasses
    },
    noOpenClasses () {
      let noOpenClasses = true
      this.getCoursesForStudent().forEach(course => {
        if (this.hasOpenClasses(course.id)) noOpenClasses = false
      })
      return noOpenClasses
    },
    applyDiscountCode (discountCode) {
      this.appliedDiscountCode = discountCode
    },
    applyGiftCard (giftCard) {
      this.appliedGiftCard = giftCard
    },
  },
  created () {
    // we need either a new student flag or an existing student id
    if (!this.newStudent && !this.studentId) this.$router.push({name: 'GuardianDashboard'})
    if (this.isAdultStudent && !this.newStudent) this.form.student = this.$clone(this.user)
  },
  async mounted () {
    //temporary redirect to typeform
    window.location.replace('https://sbcs.typeform.com/to/ejeLK10c')
    
    this.classes = await this.$classes().classList()
    this.retrieveStudents()
    if (this.studentId) {
      this.student = (await this.$firestore.collection('users').doc(this.studentId).get()).data()
      if (this.isAdultStudent && !this.student.classes) this.student.classes = []
    } else {
      console.log('new student')
    }
    this.retrieveScholarships()
  },
  updated () {
    this.setUpStripeElement()
  }
}
</script>

<template lang="pug">
  .guardian-signup-main
    .guardian-signup-container(
      v-if='user'
    )
      template(
        v-if='newStudent'
      )
        .header
          .title {{enrollmentTitle}}
        .student-holder
          .pro-form
            .form-row(
              v-if='!user.user_type.includes("ADULT_STUDENT")'
            )
              pro-input(
                :options='{type: "checkbox", prompt: "I am enrolling myself."}'
                v-model='selfEnrolling'
              )
            .form-row
              pro-input(
                :options='formOptions.student.name'
                v-model='form.student.name'
                )
            .form-row
              pro-input(
                :options='getBirthdayInputOptions()'
                v-model='form.student.birthday'
                )
            .form-row
              pro-select(
                :options='createOptions(ethnicities)'
                title='Ethnicity'
                v-model='form.student.ethnicity'
              )
            .form-row
              pro-select(
                :options='createOptions(genders)'
                title='Gender'
                v-model='form.student.gender'
              )
            .form-row(
              v-if='form.student.gender === "Prefer to self-describe"'
            )
              pro-input(
                :options='{title: "Participant\'s self-described gender"}'
                v-model='form.student.gender_self_description'
              )
            // LOCATION
            .form-row
              pro-input(
                :options='{type: "checkbox", prompt: "This participant is not in the United States."}'
                v-model='form.student.outside_of_us'
              )
            .form-row
              pro-input(
                :options='{title: "City"}'
                v-model='form.student.city'
              )
            .form-row(
              v-if='!form.student.outside_of_us'
            )
              pro-select(
                :options='createOptions(states)'
                title='State'
                v-model='form.student.state'
              )
            .form-row(
              v-else
            )
              pro-select(
                :options='createOptions(countries)'
                title='Country'
                v-model='form.student.country'
              )
            template(
                v-if='isAdultStudent'
              )
                .form-row
                  pro-input(
                    :options='{type: "checkbox", prompt: formOptions.adultStudent.military_or_vet.title}'
                    v-model='form.adultStudent.military_or_vet'
                  )
                .form-row
                  pro-select(
                    :options='createOptions(employmentStatus)'
                    title='Current employment status'
                    v-model='form.adultStudent.employment_status'
                  )
                .form-row
                  pro-select(
                    :options='createOptions(educationLevels)'
                    title='Highest level of education'
                    v-model='form.adultStudent.education_level'
                  )
                .form-row
                  pro-input(
                    v-model='form.student.previous_coding_experience'
                    :options='{title: "What experience do you have with computer science/coding?",errorIf: formOptions.student.previous_coding_experience.errorIf}'
                  )
                .form-row
                  pro-input(
                    :options='formOptions.adultStudent.coding_barriers'
                    v-model='form.adultStudent.coding_barriers'
                  )
                .form-row
                  pro-input(
                    :options='formOptions.adultStudent.message'
                    v-model='form.adultStudent.message'
                  )
      .header
        .title Sign Up for Classes
        .subtitle(
          v-if='!newStudent'
        ) {{student.name}}
      .courses-holder.font-1-bold(
        v-if='!getCoursesForStudent().length'
      ) There are no courses available for this student's age.
      .no-classes-available(
        v-else-if='noOpenClasses()'
      ) There are no classes for this student's age group currently open for enrollment. Click the Help button (bottom right) to reach out if you have any questions.
      template(
        v-else
      )
        .courses-holder
          .course(
            v-for='course in getCoursesForStudent()'
            v-if='hasOpenClasses(course.id)'
          )
            .title {{course.name}}
            .ages(v-if='course.courseType == "youth"') Ages {{course.minAge}} - {{course.maxAge}}
            //- .ages(v-else) Adult course
            .description {{course.description}}
            .class-holder
              .class(
                v-for='(aClass, classId) in classes'
                v-if='aClass.course_id === course.id && !aClass.done && !isClosed(classId, aClass)'
                @click='!isClassFull(classId) && onClassClick(classId)'
                :class='getClassClasses(classId)'
              )
                .month {{aClass.month}}
                .day {{aClass.day}}
                .time {{aClass.time}}
                .details {{aClass.details}}
        .checkout-container
          .pro-form
            .row-title Total cost 
          .total-form
            .line-items-holder
              .line-item
                .description Your total cost for {{totalClasses}} class{{totalClasses == 1 ? '' : 'es'}}
                .price ${{totalClasses * costPerClass}}
              .line-item(
                v-if='appliedGiftCard'
              )
                .description Gift Card
                .price -${{totalGiftCardAmount}}
              .line-item(
                v-if='appliedDiscountCode'
              )
                .description Discount Code "{{appliedDiscountCode.code}}"
                .price -${{totalDiscountCodeAmount}}
              .promotion-row.add-gift-card
                add-gift-card(
                  @applyCard='applyGiftCard'
                )
              .promotion-row.discount-code
                discount-code(
                  @applyCode='applyDiscountCode'
                )
            .checkout-total
              .title Total Payment
              .total {{$toCurrency(totalCost > 0 ? totalCost : 0)}}
          .apply
            .copy Need assistance? You can {{hasPendingScholarship ? 'update your' : 'fill out an'}} application for a scholarship by clicking below.
            .pro-button.minor(
              @click='applyingForScholarship = !applyingForScholarship'
            ) {{applyingForScholarship ? "Nevermind" : "Apply"}}
            transition(
              name='fade'
              v-if='applyingForScholarship'
              )
              .scholarship-application
                .pro-form
                  .form-row(
                    v-for='(options, key, idx) in formOptions.scholarship'
                    v-if='key !== "non_taxable_incomes"'
                  )
                    pro-input(
                      :options='options'
                      v-model='form.scholarship[key]'
                    )
                    .helper-text(
                      v-if='key === "can_pay" && hasPendingScholarship'
                    ) This amount will be added to your current pending scholarship for a total of 
                      b ${{newScholarshipTotal}}
                  .row-subtitle Please select other sources of non-taxable income you receive. (select all that apply)
                  .non-taxable-incomes-holder
                    .income(
                      v-for='income in nonTaxableIncomes'
                    ) 
                      input(
                        type='checkbox'
                        :id='income'
                        :value='income'
                        v-model='form.scholarship.non_taxable_incomes'
                      )
                      label(
                        :for='income'
                      ) {{income}}
          .checkout
            .card-holder(
              :class='applyingForScholarship || totalCost <= 0 ? "hideMe" : ""'
            )
              span Enter your card information below:
              #card-element
            .checkout-btn.pro-button.major(
              v-if='isLoading'
            )
              i.material-icons.spin-me refresh
            .checkout-btn.pro-button.major(
              v-else
              @click='onSubmit()'
            ) {{applyingForScholarship ? "Apply" : "Sign Up"}}
            .disclaimer By continuing, I agree with South Bend Code School’s 
              a(
                target='_blank'
                href='/legal/Terms of Service.pdf'
              ) Terms of Service
              |  & 
              a(
                target='_blank'
                href='/legal/Privacy Policy.pdf'
              ) Privacy Policy
              | .



</template>

<style lang="sass" scoped>
  .guardian-signup-main
    .guardian-signup-container
      padding: 3rem
      max-width: 950px
      > .header
        margin-bottom: 2rem
        width: fit-content
        .title
          font-size: 3rem
          font-weight: bold
        .subtitle
          font-size: 1.5rem
      .pro-form
        .form-row
          margin-bottom: 1rem
      .student-holder
        width: 80%
        padding: 1rem
        margin: 2rem auto
      .courses-holder
        margin-bottom: 2rem
        .course
          .title
            font-weight: bold
            font-size: 1.5rem
            color: $orange
          .class-holder
            display: flex
            flex-flow: wrap
            margin-bottom: 2rem
            .class
              min-width: 175px
              margin: 0.5rem
              cursor: pointer
              transition: 0.25s
              box-shadow: 0 0 3px 0 black
              border-radius: 10px
              padding: .5rem
              text-align: center
              position: relative
              overflow: hidden
              &:hover
                background-color: $lightgrey
                transition: 0.25s
              &.chosen
                background-color: $orange
                color: white
                border-color: $orange
                transition: 0.25s
              &.full, &.enrolled
                &:after
                  position: absolute
                  width: 120%
                  top: 2rem
                  left: -10%
                  font-weight: 800
                  padding: 1rem 0
                  transform: rotate(-25deg)
                  text-align: center
              &.full
                &:after
                  content: 'CLASS FULL'
                  background-color: $mediumgrey
              &.enrolled
                &:after
                  content: 'ENROLLED'
                  background-color: $orange
                  color: white
              .month
                font-weight: 600
                font-size: 18px
                margin-bottom: 0.25rem
              .details
                margin-top: 0.5rem
                font-size: 12px
      .no-classes-available
        padding: 0 2rem 4rem 2rem
      .apply
        border-radius: 0.5rem
        background-color: $lightgrey
        width: calc(100% - 2rem)
        margin: 2rem auto
        padding: 1rem
        .copy
          text-align: center
        .pro-button
          margin: 0.5rem auto 1rem auto
        .scholarship-application
          text-align: left
          width: 90%
          margin: auto
          .helper-text
            color: $darkgrey
            font-size: 0.8em
            margin-bottom: 1rem
            b
              color: $orange
      .checkout-container
        .pro-form
          .row-title
            font-size: 1.5rem
            color: darkorange
            margin-bottom: 1.5rem
        .total-form
          border: thin solid grey
          border-radius: 8px
          padding: 40px
          .line-items-holder
            .line-item
              display: grid
              grid-template-columns: max-content auto
              border-bottom: thin solid lightgrey
              padding: 15px 0
              font-size: 14px
              .price
                justify-self: end
            .promotion-row
              margin-top: 1rem
          .checkout-total
            display: grid
            grid-template-columns: auto auto
            padding: 40px 0
            align-items: center
            .title
              font-size: 24px
              color: $orange
            .total
              justify-self: end
              font-size: 48px
              font-weight: bold
              color: $orange
          .payment-options-holder
            display: grid
            grid-template-columns: calc(50% - 25px) 50px calc(50% - 25px)
            padding-bottom: 24px
          @media(max-width:475px)
            .checkout-total
              grid-template-columns: auto
              > *
                justify-self: center !important //.total won't listen otherwise
            .payment-options-holder
              grid-template-columns: auto
              > *
                margin-bottom: 8px
        .discount-container
          max-width: 300px
          margin: auto
          .discount-calculation
            margin-bottom: 1rem
            .line-item
              display: grid
              grid-template-columns: 1fr auto
        .checkout
          text-align: center
          .card-holder
            margin: 1.5rem auto
            &.hideMe
              display: none
            #card-element
              background-color: $lightgrey
              border-radius: 0.5rem
              padding: 0.5rem
              margin: 0.5rem auto
              max-width: 400px
          .checkout-btn
            margin: auto
            font-size: 2rem
            font-weight: 600
            padding: 0.5rem 2rem
            width: 15rem
          .disclaimer
            margin-top: 0.5rem
            color: $darkgrey
            font-size: 0.8rem

    </style>